import omit from 'lodash.omit'
import { makeAutoObservable } from 'mobx'
import { ViewSortFragment } from 'types/graphql'

export class SortManager {
  public sorts: ViewSortFragment[] = []
  private _databaseValue: ViewSortFragment[] = []

  constructor() {
    makeAutoObservable(this)
  }

  public get hasUnsavedChanges(): boolean {
    if (this.sorts.length !== this._databaseValue.length) {
      return true
    }

    for (let i = 0; i < this.sorts.length; i++) {
      const clientSort = this.sorts[i]
      const databaseSort = this._databaseValue[i]
      if (
        clientSort?.columnTemplateGeneratedId !== databaseSort?.columnTemplateGeneratedId ||
        clientSort?.mode !== databaseSort?.mode
      ) {
        return true
      }
    }
    return false
  }

  public initializeSorts(sorts: ViewSortFragment[]) {
    this.setSorts(sorts)
    this._databaseValue = sorts.map((s) => omit(s, '__typename'))
  }

  public reset() {
    this.sorts = Array.from(this._databaseValue)
  }

  public save() {
    this._databaseValue = Array.from(this.sorts)
  }

  public setSorts(sorts: ViewSortFragment[]) {
    this.sorts = sorts.map((s) => omit(s, '__typename'))
  }

  public removeSortsForColumn(columnGeneratedId: string) {
    this.sorts = this.sorts.filter((s) => s.columnTemplateGeneratedId !== columnGeneratedId)
  }

  public get databaseProtocol(): ViewSortFragment[] {
    return this._databaseValue
  }
}
